const realpressBecomeAgent = () => {
	const becomeAgentNode = document.querySelector( '#realpress-become-an-agent' );
	if ( ! becomeAgentNode ) {
		return;
	}
	const containerNode = becomeAgentNode.querySelector( '.realpress-become-an-agent-container' );
	const formNode = containerNode.querySelector( 'form' );
	if ( ! formNode ) {
		return;
	}

	const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
	const btnNode = formNode.querySelector( 'button' );
	btnNode.addEventListener( 'click', function( event ) {
		event.preventDefault();
		const firstName = formNode.querySelector( '[name="realpress-baa-firstname"]' ).value || '';
		const lastName = formNode.querySelector( '[name="realpress-baa-lastname"]' ).value || '';
		const agencyName = formNode.querySelector( '[name="realpress-baa-agencyname"]' ).value || '';
		const phoneNumber = formNode.querySelector( '[name="realpress-baa-phonenumber"]' ).value || '';
		const additionalInfo = formNode.querySelector( '[name="realpress-baa-additional-information"]' ).value || '';
		const termAndCondition = formNode.querySelector( '[name="realpress-baa-terms-and-conditions"]' ).checked;
		const warningNode = formNode.querySelector( '.realpress-baa-warning' );
		const data = {
			first_name: firstName,
			last_name: lastName,
			agency_name: agencyName,
			phone_number: phoneNumber,
			additional_info: additionalInfo,
			terms_and_conditions: termAndCondition,
		};

		wp.apiFetch( {
			path: '/' + restNamespace + '/become-an-agent', method: 'POST', data,
		} ).then( ( res ) => {
			if ( res.status === 'success' ) {
				warningNode.classList.remove( 'failed' );
				containerNode.innerHTML = res.msg;
			} else {
				warningNode.classList.add( 'failed' );
				warningNode.innerHTML = res.msg;
			}
		} ).catch( ( err ) => {
			console.log( err );
		} );
	} );
};

export default realpressBecomeAgent;
